import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { AdminDashboard } from "./AdminDashboard";
import { CustomerDashboard } from "./CustomerDashboard";
import { UserDashboard } from "./UserDashboard";
import { Loader } from "../../Common/Loader";
import { useDispatch } from "react-redux";
import { getPaymentMethodList } from "../../Redux/Slice/PaymentMethod/GetPaymentMethodListSlice";
export const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [confirmModel, setConfirmModel] = useState({
    visible: false,
    type: "ADD_PAYMENT",
  });
  const userData = JSON.parse(localStorage.getItem("userData"));

  const isSuperAdmin =
    userData &&
    (userData?.role?.name == "superadmin" ||
      userData?.role?.name == "admin" ||
      userData?.isUserOfVoxApp);

  const getCardList = async () => {
    setLoading(true);
    try {
      const result = await dispatch(
        getPaymentMethodList({ searchText: "", page: 1, limit: 200 })
      );
      if (
        getPaymentMethodList.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        const data = Array.isArray(result?.payload.data)
          ? result.payload.data
          : [];
        const defaultPaymentMethod = data?.some((card) => card.isDefault);
        if (data?.length && !defaultPaymentMethod) {
          setConfirmModel({
            visible: true,
            type: "ADD_DEFAULT_CARD",
          });
        } else if (!data?.length) {
          setConfirmModel({
            visible: true,
            type: "ADD_PAYMENT",
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isSuperAdmin) {
      getCardList();
    }
  }, []);

  const onConfirm = () => {
    setConfirmModel({
      visible: false,
      type: "ADD_PAYMENT",
    });
    navigate("/addPayment");
  };
  return (
    <div>
      {loading ? <Loader /> : null}
      {confirmModel?.visible ? (
        <ConfirmModel
          onAccept={onConfirm}
          onReject={() => {
            setConfirmModel({
              visible: false,
              type: "ADD_PAYMENT",
            });
            navigate("/dashboard");
          }}
          title="Warning!"
          yes={
            confirmModel?.type == "ADD_PAYMENT"
              ? "Add Payment"
              : "Add Default Card"
          }
          hideYes={confirmModel?.type != "ADD_PAYMENT"}
          no="Skip"
          message={
            confirmModel?.type == "ADD_PAYMENT"
              ? "Please add Payment Method to proceed."
              : "Please select a card to set as your default payment method."
          }
        />
      ) : (
        ""
      )}
      {isSuperAdmin ? (
        <AdminDashboard />
      ) : userData?.role?.name === "company" ? (
        <CustomerDashboard />
      ) : (
        <UserDashboard />
      )}
    </div>
  );
};
